export const STATUS = {
	IDLE: "idle",
	REQUEST: "request",
	PENDING: "pending",
	SUCCESS: "success",
	FAILED: "failed",
	REFETCH: "REFETCH",
	DRAFT: "draft",
	DELETE: "DELETE",
};
